import { ALZA_SCORING_CHART_TOGGLE_DATA_TABLE } from './constants'

// eslint-disable-next-line
export function alzaScoringChartToggleDataTable(module, id, blockKey, customData) {
    return {
        type: ALZA_SCORING_CHART_TOGGLE_DATA_TABLE,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}
